import { registerService } from 'serviceResolver';

registerService('localStorage', localStorage);
